module.exports = __webpack_public_path__ + "media/CN_001.770e42ac.mp3";